import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "glass-header shadow-sm" : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#home" data-testid="logo-link" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-navy flex items-center justify-center group-hover:bg-orange transition-colors">
            <span className="text-white font-extrabold text-lg leading-none">D</span>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-extrabold text-navy text-base sm:text-lg tracking-tight">Digital Hights</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-medium">Pune · India</span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}-link`}
              className="text-sm font-medium text-slate-700 hover:text-orange transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-orange after:transition-all hover:after:w-full"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`tel:${BUSINESS.phone}`}
            data-testid="header-call-now-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-orange hover:bg-[var(--orange-dark)] text-white font-semibold text-sm px-4 py-2.5 rounded-full transition-all btn-shine shadow-sm hover:shadow-md"
          >
            <Phone size={16} />
            <span>Call Now</span>
          </a>
          <a
            href={`tel:${BUSINESS.phone}`}
            data-testid="header-call-now-mobile-btn"
            className="sm:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-orange text-white"
            aria-label="Call Now"
          >
            <Phone size={16} />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-200 text-navy"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}-link`}
                className="py-3 text-base font-medium text-slate-700 border-b border-slate-100"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
